import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private _router: Router) { }

    intercept(
        request: HttpRequest<unknown>,
        next: HttpHandler
    ): Observable<HttpEvent<unknown>> {
        const token = sessionStorage.getItem("token");

        if (!token) {
            sessionStorage.clear();
        }

        if (request.url.includes('amazonaws.com')) {
            return next.handle(request).pipe(finalize(() => {}));
        }

        const modifiedReq = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${token}`),
        });

        return next.handle(modifiedReq).pipe(
            finalize(() => { })
        );
    }
}
